import { PricingItem, QuoteService } from 'quote-domain-core';
import { PricingItemCommercialService } from '../pricing-item/pricing-item-commercial-service';
import { PricingItemCorridorService } from '../pricing-item/pricing-item-corridor-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceArticlePricingService {
    constructor(
        private readonly pricingItemCorridorService: PricingItemCorridorService,
        private readonly pricingItemCommercialService: PricingItemCommercialService
    ) {
    }

    public calculateArticleDistanceAndColorAndPriceFixedCorridorMode(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.calculateArticleDistanceAndColorAndPriceFixedCorridorMode(pricingItem, quoteService.nonNegociableArticleColor);
        });
    }

    public calculateArticleDistanceAndColorAndPriceFixedPriceMode(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.calculateArticleDistanceAndColorAndPriceFixedPriceMode(pricingItem, quoteService.nonNegociableArticleColor);
        });
    }

    public applySplitOnAppliedPrice(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.splitAppliedPrice(pricingItem, quoteService.nonNegociableArticleColor);
        });
    }

    public copyArticleAppliedPriceToOldAppliedPrice(quoteService: QuoteService): void {
        if (!quoteService.distance) {
            return;
        }
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.copyArticleAppliedPriceToOldAppliedPrice(pricingItem);
        });
    }

    private forEachPricingItem(quoteService: QuoteService, callback: (pricingItem: PricingItem) => void): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(callback);
        });
    }
}
